export default __webpack_public_path__ + "static/media/more.73231664.svg";